import { Button, Card, message } from 'antd';
import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router';
import { QuestionCircleTwoTone } from '@ant-design/icons';
import BinLocationService from '../../../services/Wash-service/BinLocationService';
import ResponseMessage from '../../Comman/Notification/ResponseMessge';

const GSMInwardConfirm = ({ userdata }) => {

    const location = useLocation();
    const navigate = useNavigate();
    const [binId, setBinId] = useState();

    useEffect(() => {
        const fetchKanbanData = async () => {
            const queryParams = new URLSearchParams(location.search);
            const bin_id = queryParams.get('binId');

            setBinId(bin_id);

            if (!bin_id) {
                ResponseMessage.error({ message : "No Bin ID provided."});
                return;
            }
        };

        fetchKanbanData();

    }, [location, userdata.su_id, navigate]);

    const handleConfirm = async () => {
        if (!binId) {
            ResponseMessage.error({ message : "No Bin ID available."});
            return;
        }

        try {
            const response = await BinLocationService.GSM_inward(binId, userdata.su_id);
            console.log(response.message);

            if (response && response.data) {
            } else {
                ResponseMessage.success({ message : response.message});
                navigate(-1);
            }
        } catch (error) {
            console.error("Error in handleConfirm:", error);
            ResponseMessage.error({ message : error.message || "An error occurred."});
            navigate(-1);
        }
    };

    return (
        <>
            <div
                style={{
                    display: 'flex',
                    alignItems: 'flex-start', // Align the card towards the top
                    flexDirection: 'column',
                    height: '100vh', // Keep the vertical space in view height
                }}
            >
                <Card
                    title={
                        <div style={{ fontSize: '24px', fontWeight: 'bold', gap: '30px' }}>
                            <QuestionCircleTwoTone />  Confirm Inward!
                        </div>
                    }
                    style={{
                        width: 600,
                        boxShadow: '0px 6px 12px rgba(0, 0, 0, 0.3)',
                        borderRadius: '10px',
                        padding: '20px',
                    }}
                >
                    <p
                        style={{
                            fontSize: '18px',
                        }}
                    >
                        Are you sure you want to confirm the inward of Bin <strong>{binId}</strong> ?

                    </p>
                    <Button
                        type="primary"
                        onClick={handleConfirm}
                        style={{
                            width: '100%',
                            marginTop: '20px', 
                            padding: '10px', 
                            fontSize: '16px', 
                        }}
                    >
                        Confirm Inward
                    </Button>
                </Card>
            </div>

        </>
    )
}

export default GSMInwardConfirm;
